import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { CirclesInterface } from '../../widget-photos-teaser-circle.props';

import './widget-photos-teaser-circle-circles.scss';

interface WidgetPhotosTeaserCircleCirclesInterface {
    circles: CirclesInterface[];
}

const WidgetPhotosTeaserCircleCircles: React.FC<WidgetPhotosTeaserCircleCirclesInterface> = ({ circles }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className="circles">
            <div className="circles__list">
                { circles.map((item) => (
                    <a
                        className="circles__list__item"
                        href={item.url}
                        key={item.img}
                        target={item.target}
                        rel={item.target === '_blank' ? 'nofollow noopener' : ''}
                    >
                        <div className="circles__list__item__main">
                            <div className="circles__list__item__image">
                                <picture>
                                    <source srcSet={item.img}/>
                                    <img src={item.img} alt={item.title}/>
                                </picture>
                            </div>
                        </div>
                        <div className="circles__list__item__text">
                            {item.title}
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default WidgetPhotosTeaserCircleCircles;
